/* src/app/components/item-details/item-details.component.scss */
th,
td {
  padding: 15px;
}
.hr {
  border-top: 1px solid #0071bb;
}
.centerText {
  text-align: center;
}
.no-right-padding {
  padding-right: 0px;
}
.e-acrdn-header-content {
  font-size: 20px !important;
  font-family: open_sansregular, sans-serif !important;
  color: #0071bb !important;
  font-weight: 500 !important;
  text-decoration: none !important;
  cursor: pointer !important;
}
.e-accordion .e-acrdn-item .e-acrdn-header .e-toggle-icon {
  display: table;
  font-size: 14px;
  height: 40px;
  min-height: 40px;
  min-width: 24px;
  position: absolute;
  right: 15px;
  top: 0;
  color: #1b70bb !important;
}
.table > tbody > tr > td,
.table > tbody > tr > th,
.table > tfoot > tr > td,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > thead > tr > th {
  border-top: none !important;
}
.e-dialog .e-dlg-content {
  padding: 0;
}
#dialog .card {
  margin-bottom: 0;
  border: solid 1px #8c8c8c;
}
#haStateHistoryDetailsDialog_dialog-content {
  padding: 0;
}
#dialog .card-body {
  padding: 0 0 10px 0;
}
#dialog .card-footer {
  text-align: center;
  background-color: #ffffff;
  border-top: none;
  padding-bottom: 20px;
}
.card-body thead,
tbody,
tfoot,
tr,
td,
th {
  border: none !important;
}
#dialog .card-body .table-inner td {
  padding-left: 15px;
}
.status .status-block {
  float: left;
  margin-bottom: 50px;
}
.accordion-links a {
  font-size: 13px;
}
.ha-history-link {
  font-size: 13px;
}
.ha-state-history-dialog {
  margin-bottom: 0;
  border: solid 1px #8c8c8c;
}
.ha-state-history-dialog .card-body {
  padding: 0 0 10px 0;
}
.ha-state-history-dialog .card-footer {
  text-align: center;
  background-color: #ffffff;
  border-top: none;
  padding-bottom: 20px;
}
.ha-state-history-dialog .card-body .table-inner td {
  padding-left: 15px;
}
/*# sourceMappingURL=item-details.component.css.map */
